import {useEffect, useMemo,useState} from 'react';
import { RouterProvider } from 'react-router-dom';
import {createInstance, MatomoProvider} from "@datapunt/matomo-tracker-react";
import { ThemeProvider } from '@mui/material';
import { isNil } from 'lodash';

import { initializeAppEnv } from '../packages/configuration/initializeAppEnv';
import { localStorageFuncs } from '../packages/helpers';
import { NotifyCode } from '../packages/helpers/popup/exception.config';
import { Popup } from '../packages/ui';
import initializeMuiPro from '../packages/ui/muiPro';
import theme from '../packages/ui/theme';
import { router } from '../routes/routes';

import '../assets/styles/custom.css';

const urlBase = "https://ratp.matomo.cloud/";
const siteDev = 44;
const siteProd = 43;

const MatomoProviderWithChildren: React.FC<any> = MatomoProvider;

const getMatomoInstance = () => {
	const url = urlBase;
	let site = 0;
	if (globalThis.___STTRCONF___.env === 'prd') {
		site = siteProd;
	} else {
		site = siteDev;
	}
	if (site > 0) {
		return createInstance({
			disabled: false, // optional, false by default. Makes all tracking calls no-ops if set to true.
			heartBeat: {
				active: true, // optional, default value: true
				seconds: 10, // optional, default value: `15
			},
			linkTracking: false, // optional, default value: true
			siteId: site,
			urlBase: url,
		});
	} else {
		return undefined;
	}
};


const App = () => {
	const [advertising, setAdvertising] = useState('Chargement...');
	const [isLoading, setIsLoading] = useState<boolean>(
		!isNil(globalThis.___STTRCONF___)
	);

	const handleLoadConf = async () => {
		if (!isNil(globalThis.___STTRCONF___)) {
			const env = initializeAppEnv();
			localStorageFuncs.set('smtr-appEnv', JSON.stringify(env));
			setIsLoading(false);
		} else {
			setAdvertising(NotifyCode.ERR_TECH_027);
		}
	};

	useEffect(() => {
		handleLoadConf();
		initializeMuiPro();

		const originalSetItem = globalThis.localStorage.setItem;
		localStorage.setItem = function (key, value) {
			if (key === 'lastSyncTimeStamp') {
				const event = new Event('newLastSyncTimeStamp') as CustomEvent;
				event.value = value;
				event.key = key;
				document.dispatchEvent(event);
			}
			originalSetItem.apply(this, [key, value]);
		};

		// listens for last update events sent by the serviceWorker
		if (navigator.serviceWorker) {
			navigator.serviceWorker.addEventListener('message', (event) => {
				if (event.data?.timeStamp) {
					globalThis.localStorage.setItem(
						'lastSyncTimeStamp',
						event.data.timeStamp
					);
				}
			});
		}
		globalThis.addEventListener('sttrConfReady', handleLoadConf);

		return () => {
			globalThis.removeEventListener('sttrConfReady', handleLoadConf);
		};
	}, []);

	const matomoInstance = useMemo(() => {
		if (!isLoading && globalThis.___STTRCONF___) {
			return getMatomoInstance();
		}
		return undefined;
	}, [isLoading]);

	if (isLoading) {
		return <div>{advertising}</div>;
	}

	const applicationContent = (
		<ThemeProvider theme={theme}>
			<RouterProvider router={router} />
			<Popup />
		</ThemeProvider>
	);

	if (matomoInstance) {
		return (
			<MatomoProviderWithChildren value={matomoInstance}>
				{applicationContent}
			</MatomoProviderWithChildren>
		);
	}

	return applicationContent;
};

export default App;

interface CustomEvent extends Event {
	value: string;
	key: string;
}

declare global {
	var ___STTRCONF___: {
		backendUrl: string;
		env: string;
		muiLicense?: string;
		version?: string;
	};
}
